
const ModalHeader = ({ title, onClose }) => (
  <div className="hvnly--builder---api_property__builder___option_card_header">
    <div className="hvnly--builder---api_property__builder___option_card_header_title_section">
      <h3 className="hvnly--builder---api_property__builder___option_card_header_title">
        {title}
      </h3>
      <div className="hvnly--builder---api_property__builder___header_action_area">
        <button 
          className="hvnly--builder---api_property__builder___header_action_link hvnly--builder---api_property__builder___header_action_close"
          onClick={onClose}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
);

export default ModalHeader;